import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";
import { findSummaryText } from "../loanDetailEditUtil";

import { rows as sectionFinancialCovenantsRows } from "./section-financial-covenants-rows";
import { rows as sectionCashManagementRows } from "./section-cash-management-rows";
import { rows as sectionLeasingRows } from "./section-leasing-rows";
import { rows as sectionDefinitionRows } from "./section-definitions-rows";

const SHORTHAND_FIELD = "LoanCovenantsAndOther";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanCovenantsAndOther extends Component {
  drawDataFinancialCovenants(data) {
    if (data.covenants) {
      if (data.covenants.dscrStabilized ||
        data.covenants.dscrFrequency ||
        data.covenants.dscrCovenants ||
        data.covenants.dscrTypeId ||
        data.covenants.debtYieldStabilized ||
        data.covenants.debtYieldFrequency ||
        data.covenants.debtYieldCovenants ||
        data.covenants.ltvStabilized ||
        data.covenants.ltvFrequency ||
        data.covenants.ltvCovenants ||
        data.covenants.occupancy ||
        data.covenants.occupancyFrequency ||
        data.covenants.occupancyCovenants ||
        data.covenants.ltc ||
        data.covenants.ltcFrequency ||
        data.covenants.ltcCovenants ||
        data.covenants.dscrAsIs ||
        data.covenants.debtYieldAsIs ||
        data.covenants.ltvAsIs ||
        data.covenants.financialCovenantsMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionFinancialCovenantsRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  drawDataCashManagement(data) {
    if (data.covenants) {
      if (data.covenants.cashSweepConditions ||
        data.covenants.cashManagementCure ||
        data.covenants.cashSweepAccount ||
        data.covenants.applicationOfFunds ||
        data.covenants.cashManagementMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionCashManagementRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  drawDataLeasing(data) {
    if (data.covenants) {
      if (data.covenants.leasingEODTrigger ||
        data.covenants.leasingEODCure ||
        data.covenants.leasingCovenants ||
        data.covenants.leasingRestrictions ||
        data.covenants.leasingMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionLeasingRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  drawDataDefinition(data) {
    if (data.covenants) {
      if (data.covenants.noiDefinition ||
        data.covenants.debtServiceDefinition ||
        data.covenants.debtYieldDefinition ||
        data.covenants.dscrDefinition ||
        data.covenants.ltvDefinition ||
        data.covenants.definitionsMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionDefinitionRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers, ...other } = this.props;
    const summaryText = findSummaryText(data, SHORTHAND_FIELD);
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Covenants and other details",
            key: LOAN_SECTION_KEYS.COVENANTS_AND_OTHER_DETAILS,
            isTitleGroup: true,
            isExpandable: false,
            hasSummaryText: true,
            summaryText,
            modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText)
          },
          {
            title: "Financial Covenants",
            key: LOAN_SECTION_KEYS.FINANCIAL_COVENANTS,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.FINANCIAL_COVENANTS}`),
            sections: [
              this.drawDataFinancialCovenants(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.financialcovenants.header",
            referenceStyles: { marginLeft: "20px" }
          },
          {
            title: "Cash Management",
            key: LOAN_SECTION_KEYS.CASH_MANAGEMENT,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.CASH_MANAGEMENT}`),
            sections: [
              this.drawDataCashManagement(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.cashmanagement.header",
            referenceStyles: { marginLeft: "20px" }
          },

          {
            title: "Leasing",
            key: LOAN_SECTION_KEYS.LEASING,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.LEASING}`),
            sections: [
              this.drawDataLeasing(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.leasing.header",
            referenceStyles: { marginLeft: "20px" }
          },

          {
            title: "Definitions",
            key: LOAN_SECTION_KEYS.DEFINITIONS,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.DEFINITIONS}`),
            sections: [
              this.drawDataDefinition(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.definitions.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
